import React from "react";
import RegisterForm from "./RegisterForm";


const RegisterMain = () => {
  return (
    <div id="react-contact" className="react-contact-page pt---100">
      <div className="container">
        <div className="row justify-content-center pb---96">
          <div className="col-lg-6">
            <RegisterForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterMain;
